import {
  HttpError,
  useGetOne,
  useNotify,
  usePermissions,
} from 'react-admin';
import { Actions } from '../constants/actions';
import hasAccess from '../utilities/hasAccess';

export type PendingReview = {
  id: string;
  action: string;
  actionInformation: Record<string, unknown>;
  proposerId: string;
  status: string;
  reasoning: string;
  submittedAt: string;
};

const usePendingReview = (
  action: Actions,
  identificationInfo: Record<string, unknown>,
  options?: { enabled?: boolean },
) => {
  const notify = useNotify();
  const { permissions } = usePermissions<Actions[]>();
  const canAccess = hasAccess(permissions, action);
  const enabled = canAccess && (options?.enabled ?? true);

  const {
    data,
    error,
    isLoading,
    refetch,
  } = useGetOne<PendingReview>(
    'reviews',
    { id: `pending?action=${action}&identificationInfo=${encodeURIComponent(JSON.stringify(identificationInfo))}` },
    {
      enabled,
      onError: (err) => {
        if (err instanceof HttpError && err.status === 404) {
          // No pending review found, return null
          return;
        }
        notify('Failed to load pending review status', { type: 'error' });
      },
    },
  );

  return {
    pendingReview: error ? null : data ?? null,
    isLoading,
    refetch,
  };
};

export default usePendingReview;
